import img1 from "../img/IMG_20230913_164134.jpg";
import img2 from "../img/374772596_623113343276722_5919751210009209983_n.jpg";
import img3 from "../img/IMG_20230913_164134.jpg";
import img4 from "../img/374772596_623113343276722_5919751210009209983_n.jpg";

export const Followers = [
  { name: "Nickson Okwemba", username: "okwe3525", img: img1 },
  { name: "Okwemba Nickson", username: "nick2511", img: img2 },
  { name: "okwesh", username: "nickson2511", img: img3 },
  { name: "Okwemba", username: "okwesh3525", img: img4 },
];